import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { DepartamentModel } from '../model/departament.model';

@Injectable()
export class DepartamentService {

    path = '/departament';

    constructor(private baseService: BaseService) { }
    
    getById(id: number) {
      return this.baseService.get(this.path, '/' + id, {});
    }
    
    getPaginated(init: number, end: number) {
      return this.baseService.get(this.path, '', { init, end });
    }

    post(departament: DepartamentModel) {
        return this.baseService.post(this.path, '/', departament);
    }
    
    put(departament: DepartamentModel) {
      return this.baseService.put(this.path, '/', departament);
    }
    
    save(departament: DepartamentModel) {
      if (departament.id) {
        return this.put(departament);
      } else {
        return this.post(departament);
      }
    }
  
    delete(id: number){
      return this.baseService.delete(this.path, '/' + id);
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/departament.service.ts